/**
 * This class exists simply to supply a different set of operators
 *
 * The address operators have some conditions in common with the text operators
 *
 * @return  {array} of operators
 */
import { TextQueryBuilder } from './TextQueryBuilder';

export class AddressQueryBuilder extends TextQueryBuilder {

  /**
   * Use a subset of the operators from the TextQueryBuilder.
   *
   * @return  {object} subset of parent conditions
   */
  static get Operators() {

    const {
      CONTAINS,
      DOES_NOT_CONTAIN,
      IS_EMPTY,
      IS_NOT_EMPTY,
    } = TextQueryBuilder.Operators;

    return { CONTAINS, DOES_NOT_CONTAIN, IS_EMPTY, IS_NOT_EMPTY };
  }
}
